// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --swiper-navigation-size: 44px;
    --swiper-theme-color: #ffffff !important;
}

.default-feed-item-swiper-pagination-page-bullet {
    margin-bottom: -1px !important;
}

.swiper-pagination-bullet-active {
    background-color: #ffffff !important;
}

.default-feed-item-swiper-pagination-override-bullet {
    opacity: 1 !important;
    width: 10px !important;
    height: 10px !important;
    background-color: transparent;
    border: 1px solid #000000;
}

.default-feed-item-swiper-pagination-full-screen-image-bullet {
    margin-bottom: 84px !important
}

/* .swiper-button-next, .swiper-button-prev {
    top: unset !important;
    bottom: 0px;
} */

.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    /* content: "⟶" !important; */
    /* color: #000; */
    color: "#fff";
    font-style: normal;
    font-weight: normal;
    text-decoration: inherit;
    font-size: 26px;
    z-index: 10;
}

.swiper-button-prev:after, .swiper-container-rtl .swiper-button-prev:after {
    /* content: "⟵" !important; */
    /* color: #000; */
    color: "#fff";
    font-style: normal;
    font-weight: normal;
    text-decoration: inherit;
    font-size: 26px;
    z-index: 10;
}

.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    top: 55%
}

.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    top: 55%
}`, "",{"version":3,"sources":["webpack://./src/pages/components/feed/templates/override.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;;;GAGG;;AAEH;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ","sourcesContent":[":root {\n    --swiper-navigation-size: 44px;\n    --swiper-theme-color: #ffffff !important;\n}\n\n.default-feed-item-swiper-pagination-page-bullet {\n    margin-bottom: -1px !important;\n}\n\n.swiper-pagination-bullet-active {\n    background-color: #ffffff !important;\n}\n\n.default-feed-item-swiper-pagination-override-bullet {\n    opacity: 1 !important;\n    width: 10px !important;\n    height: 10px !important;\n    background-color: transparent;\n    border: 1px solid #000000;\n}\n\n.default-feed-item-swiper-pagination-full-screen-image-bullet {\n    margin-bottom: 84px !important\n}\n\n/* .swiper-button-next, .swiper-button-prev {\n    top: unset !important;\n    bottom: 0px;\n} */\n\n.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {\n    /* content: \"⟶\" !important; */\n    /* color: #000; */\n    color: \"#fff\";\n    font-style: normal;\n    font-weight: normal;\n    text-decoration: inherit;\n    font-size: 26px;\n    z-index: 10;\n}\n\n.swiper-button-prev:after, .swiper-container-rtl .swiper-button-prev:after {\n    /* content: \"⟵\" !important; */\n    /* color: #000; */\n    color: \"#fff\";\n    font-style: normal;\n    font-weight: normal;\n    text-decoration: inherit;\n    font-size: 26px;\n    z-index: 10;\n}\n\n.swiper-button-next, .swiper-container-rtl .swiper-button-prev {\n    top: 55%\n}\n\n.swiper-button-prev, .swiper-container-rtl .swiper-button-next {\n    top: 55%\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
